// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../shared/font/gteestiprodisplay_bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../shared/font/gteestiprodisplay_light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../shared/font/gteestiprodisplay_regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../shared/images/accept.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "GteDisplayExtra";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "GteDisplayLight";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "GteDisplayRegular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-style: normal;
  font-weight: normal;
}
.advertisementBanner_body__429Y7 {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.advertisementBanner_body__429Y7 .advertisementBanner_closeBtn__H2VIv {
  position: absolute;
  top: 40px;
  right: 20px;
}

.advertisementBanner_header__5ml76 {
  margin-top: 14px;
}
.advertisementBanner_header__5ml76 h3 {
  font-size: 28px;
  font-family: GteDisplayExtra;
  color: #000;
}
.advertisementBanner_header__5ml76 h3 span {
  color: #9E4BFF;
}
.advertisementBanner_header__5ml76 p {
  margin-top: 10px;
  font-family: GteDisplayExtra;
  font-size: 16px;
  line-height: 18px;
}

.advertisementBanner_info__CEyWB {
  text-align: center;
  margin-top: 15px;
}
.advertisementBanner_info__CEyWB p {
  font-family: GteDisplayExtra;
  font-size: 16px;
  line-height: 20px;
}
.advertisementBanner_info__CEyWB p span {
  color: #9E4BFF;
}

.advertisementBanner_actions__aysTI {
  display: flex;
  flex-direction: column;
  grid-gap: 10px;
  width: 100%;
  margin-top: 25px;
}
.advertisementBanner_actions__aysTI div {
  width: 100%;
  padding: 14px 0;
  text-align: center;
  color: #000;
  border: 2px solid #C7FF24;
  font-size: 16px;
  line-height: 16px;
  font-family: GteDisplayBold;
  border-radius: 30px;
}

.advertisementBanner_wrapper__akI9y {
  display: flex;
  flex-direction: column;
  grid-gap: 10px;
  margin-top: 30px;
}
.advertisementBanner_wrapper__akI9y .advertisementBanner_item__5EuxS p {
  font-family: GteDisplayRegular;
  font-size: 16px;
  line-height: 18px;
  color: #000;
  padding-left: 30px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) top left no-repeat;
}
.advertisementBanner_wrapper__akI9y .advertisementBanner_item__5EuxS:nth-child(3) p {
  line-height: 21px;
}`, "",{"version":3,"sources":["webpack://./src/components/advertisementBanner/advertisementBanner.module.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;EACA,+DAAA;EACA,kBAAA;EACA,mBAAA;AACF;AAEA;EACE,8BAAA;EACA,+DAAA;EACA,kBAAA;EACA,mBAAA;AAAF;AAGA;EACE,gCAAA;EACA,+DAAA;EACA,kBAAA;EACA,mBAAA;AADF;AAOA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AALF;AAOE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AALJ;;AASA;EACE,gBAAA;AANF;AAQE;EACE,eAAA;EACA,4BAAA;EACA,WAAA;AANJ;AAQI;EACE,cAAA;AANN;AAUE;EACE,gBAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;AARJ;;AAYA;EACE,kBAAA;EACA,gBAAA;AATF;AAWE;EACE,4BAAA;EACA,eAAA;EACA,iBAAA;AATJ;AAWI;EACE,cAAA;AATN;;AAcA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;AAXF;AAaE;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,mBAAA;AAXJ;;AAeA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;AAZF;AAcI;EACE,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,sEAAA;AAZN;AAiBM;EACE,iBAAA;AAfR","sourcesContent":["@font-face {\r\n  font-family: \"GteDisplayExtra\";\r\n  src: url('../../shared/font/gteestiprodisplay_bold.otf') format(\"truetype\");\r\n  font-style: normal;\r\n  font-weight: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"GteDisplayLight\";\r\n  src: url('../../shared/font/gteestiprodisplay_light.otf') format(\"truetype\");\r\n  font-style: normal;\r\n  font-weight: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"GteDisplayRegular\";\r\n  src: url('../../shared/font/gteestiprodisplay_regular.otf') format(\"truetype\");\r\n  font-style: normal;\r\n  font-weight: normal;\r\n}\r\n\r\n// .picture {\r\n// }\r\n\r\n.body {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n\r\n  .closeBtn {\r\n    position: absolute;\r\n    top: 40px;\r\n    right: 20px;\r\n  }\r\n}\r\n\r\n.header {\r\n  margin-top: 14px;\r\n\r\n  h3 {\r\n    font-size: 28px;\r\n    font-family: GteDisplayExtra;\r\n    color: #000;\r\n\r\n    span {\r\n      color: #9E4BFF;\r\n    }\r\n  }\r\n\r\n  p {\r\n    margin-top: 10px;\r\n    font-family: GteDisplayExtra;\r\n    font-size: 16px;\r\n    line-height: 18px;\r\n  }\r\n}\r\n\r\n.info {\r\n  text-align: center;\r\n  margin-top: 15px;\r\n\r\n  p {\r\n    font-family: GteDisplayExtra;\r\n    font-size: 16px;\r\n    line-height: 20px;\r\n\r\n    span {\r\n      color: #9E4BFF;\r\n    }\r\n  }\r\n}\r\n\r\n.actions {\r\n  display: flex;\r\n  flex-direction: column;\r\n  grid-gap: 10px;\r\n  width: 100%;\r\n  margin-top: 25px;\r\n\r\n  div {\r\n    width: 100%;\r\n    padding: 14px 0;\r\n    text-align: center;\r\n    color: #000;\r\n    border: 2px solid #C7FF24;\r\n    font-size: 16px;\r\n    line-height: 16px;\r\n    font-family: GteDisplayBold;\r\n    border-radius: 30px;\r\n  }\r\n}\r\n\r\n.wrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  grid-gap: 10px;\r\n  margin-top: 30px;\r\n  .item {\r\n    p {\r\n      font-family: GteDisplayRegular;\r\n      font-size: 16px;\r\n      line-height: 18px;\r\n      color: #000;\r\n      padding-left: 30px;\r\n      background: url(\"../../shared/images/accept.png\") top left no-repeat;\r\n\r\n    }\r\n\r\n    &:nth-child(3) {\r\n      p {\r\n        line-height: 21px;\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `advertisementBanner_body__429Y7`,
	"closeBtn": `advertisementBanner_closeBtn__H2VIv`,
	"header": `advertisementBanner_header__5ml76`,
	"info": `advertisementBanner_info__CEyWB`,
	"actions": `advertisementBanner_actions__aysTI`,
	"wrapper": `advertisementBanner_wrapper__akI9y`,
	"item": `advertisementBanner_item__5EuxS`
};
export default ___CSS_LOADER_EXPORT___;
